import { useState } from 'react';
const clearIfNonEmpty = prev => prev.length > 0 ? [] : prev;
export const useInFlightToolCalls = () => {
  const [inFlightTools, setInFlightTools] = useState([]);
  const handleStreamEvent = event => {
    const raw = event;
    const eventType = raw['type'];
    if (eventType === 'CONTENT_BLOCK_START') {
      const contentBlock = raw['contentBlock'];
      if (contentBlock && (contentBlock['type'] === 'SERVER_TOOL_USE' || contentBlock['type'] === 'TOOL_USE')) {
        var _ref;
        const tool = {
          name: contentBlock['name'],
          id: (_ref = contentBlock['id']) !== null && _ref !== void 0 ? _ref : crypto.randomUUID()
        };
        setInFlightTools(prev => {
          if (prev.some(t => t.id === tool.id)) return prev;
          return [...prev, tool];
        });
      }
    } else if (eventType === 'MESSAGE_START') {
      setInFlightTools(clearIfNonEmpty);
    } else if (eventType === 'MESSAGE_END') {
      const stopReason = raw['stopReason'];
      if (stopReason !== 'TOOL_USE') {
        setInFlightTools(clearIfNonEmpty);
      }
    }
  };
  const reset = () => {
    setInFlightTools(clearIfNonEmpty);
  };
  return {
    inFlightTools,
    handleStreamEvent,
    reset
  };
};